import userStore from "stores/user";
import token from "stores/token";

let tokenData;
let userData;

token.subscribe(r => tokenData = r)
userStore.subscribe(r => userData = r)

export const upsertWatchlist = async (uid, list, name = 'Main watchlist') => {
    if (!tokenData || tokenData.length === 0)
        return []
    else {
        const data = {}
        data[name] = list
        await userStore.set({
            ...userData,
            watchlist: {
                ...userData.watchlist,
                ...data
            }
        })

        const res = await fetch('/api/watchlist/upsert', {
            method: "POST",
            headers: {'x-access-token': tokenData},
            body: JSON.stringify({
                userId: uid,
                data: list,
                list: name
            })
        })
        const response = await res.json();
        await token.set(response?.data.token ?? '')
    }
};